var _rect, _line, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ticket",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7067",
    "data-name": "Rectangle 7067",
    width: 25,
    height: 25,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_221",
    "data-name": "Line 221",
    y2: 14,
    transform: "translate(9 6)",
    fill: "none",
    stroke: "#e8b965",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64996",
    "data-name": "Path 64996",
    d: "M24,67.066a.786.786,0,0,1,.637-.776,3.194,3.194,0,0,0,0-6.249A.786.786,0,0,1,24,59.264V56.8a.8.8,0,0,1,.8-.8H43.9a.8.8,0,0,1,.8.8v2.468a.786.786,0,0,1-.637.776,3.194,3.194,0,0,0,0,6.249.786.786,0,0,1,.637.776v2.468a.8.8,0,0,1-.8.8H24.8a.8.8,0,0,1-.8-.8Z",
    transform: "translate(-21.612 -50.427)",
    fill: "none",
    stroke: "#e8b965",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.d97f5594c3c1f6e7bbda03501f0bba3c.svg";
export { ForwardRef as ReactComponent };